import { List, ListItem, Typography, styled } from "@mui/material";
import moment from "moment";
import CollapsibleSection from "../../../components/collapsible-section/collapsible-section";
import { displayDateFormat } from "../../../constants";
import { IRootState } from "../../../redux/root.reducer";
import { useAppSelector } from "../../../redux/store";
import { canAccessStubRules } from "../../../service/user-permission";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const StubbingRules = ({ className }: IWithClassName) => {
    const { details, isLoading } = useAppSelector(
        ({ listPage }) => listPage.listDetails,
    );

    const role = useAppSelector(({ auth }: IRootState) => auth.user?.role);
    const isAuthorized = canAccessStubRules(role);

    return isAuthorized && details?.stubs?.length ? (
        <CollapsibleSection
            className={className}
            title="Stubbing Rules"
            subTitle="Below are the historical stubs for this list, each with its effective date."
            collapsible={true}
            collapsed={true}
            isLoading={isLoading}
        >
            <>
                <ListItem className="stub-title">
                    <Typography className="stub-date">Date</Typography>
                    <Typography className="stub-name">Stub</Typography>
                </ListItem>
                <List>
                    {details?.stubs?.map((stub) => (
                        <ListItem key={stub.at} className="stub-item">
                            <Typography className="stub-date">
                                {moment.utc(stub.at).format(displayDateFormat)}
                            </Typography>
                            <Typography className="stub-name">
                                {stub.stub}
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            </>
        </CollapsibleSection>
    ) : (
        <></>
    );
};

export default styled(StubbingRules)(({ theme }: IWithThemeProps) => ({
    paddingTop: theme?.spacing(3),
    fontSize: 20,
    color: theme?.palette.announcement.primaryColor,

    ".MuiListItem-root": {
        color: theme?.palette.historicalSnapshsot.textColor,
        padding: theme?.spacing(4, 0),
        height: 80,
        borderBottom: `1px solid ${
            theme?.palette.detailsPane.borderBottom ?? ""
        }  `,
    },
    ".MuiListItem-root:last-child": {
        border: "none",
    },
    ".stub-title": {
        p: {
            fontWeight: 600,
        },
    },
    ".stub-date": {
        flexBasis: "40%",
        paddingLeft: theme?.spacing(5),
    },
    ".stub-name": {
        flexBasis: "50%",
    },
    ".MuiDialogContentText-root": {
        textDecoration: "none",
    },
}));
